import React from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  Circle
} from "react-google-maps";
import { compose, withProps } from "recompose";
import { GOOGLE_MAP_URL } from "../../../../constants";

const color = "RED";

const StationLocation = (props) => {
  const {
    latitude,
    longitude,
    onChange
  } = props;

  const onClick = (e) => {
    onChange([{
      key: "latitude",
      value: e.latLng.lat()
    }, {
      key: "longitude",
      value: e.latLng.lng()
    }]);
  };

  return (
    <GoogleMap
      defaultZoom={12}
      defaultCenter={{
        lat: 40.15,
        lng: 44.51
      }}
      onClick={onClick}
    >

      {longitude && latitude ?
        <Marker position={{
          lng: longitude,
          lat: latitude
        }}/>
        : null}
      {longitude && latitude ?
        <Circle
          radius={1}
          center={{
            lng: longitude,
            lat: latitude
          }}
          options={{
            strokeColor: color,
            fillColor: color,
            fillOpacity: 0.4,
            strokeWeight: 1,
          }}
          draggable
          onDragEnd={onClick}
        />
        : null}

    </GoogleMap>
  );
};

export default compose(
  withProps({
    googleMapURL: GOOGLE_MAP_URL,
    loadingElement: <div style={{ height: "100%" }}/>,
    containerElement: <div style={{ height: "400px" }}/>,
    mapElement: <div style={{ height: "100%" }}/>,
  }),
  withScriptjs,
  withGoogleMap
)(StationLocation);



// WEBPACK FOOTER //
// ./src/views/pages/chargers/stations/StationLocation.js